export { DrillPageFooter } from "#footer";
